import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import Message from './Message';
import PasswordInput from './PasswordInput';

// Reusable re-authentication prompt for step-up-gated actions (order
// placement, admin deletes/admin-role grants, refunds, email change).
// The caller owns `show` and passes a `password => Promise` handler.
const StepUpPasswordModal = ({
  show,
  title = 'Confirm your password',
  description = 'For your security, please re-enter your password to continue.',
  onCancel,
  onConfirm,
  loading = false,
  error = '',
}) => {
  const [password, setPassword] = useState('');

  const handleHide = () => {
    setPassword('');
    onCancel();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password || loading) return;
    onConfirm(password);
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{description}</p>
          {error && <Message variant='danger'>{error}</Message>}
          <PasswordInput
            id='step-up-password'
            label='Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            autoComplete='current-password'
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant='primary' type='submit' disabled={loading || !password}>
            {loading ? 'Verifying…' : 'Confirm'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default StepUpPasswordModal;
